import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DeviceFilters } from '../../../model/filters/device-filters';
import { FilterMatchMode, FilterMetadata, FilterOperator } from 'primeng/api';
import { DeviceMeasurement } from '../../../model/device-measurement';
import { EntityWithUuid } from '../../../model/custom/entity-with-uuid';
import { Organization } from '../../../model/organization';
import { Tenant } from '../../../model/tenant';

@Component({
  selector: 'app-device-measurements-selector',
  templateUrl: './device-measurements-selector.component.html',
  styleUrls: ['./device-measurements-selector.component.scss']
})
export class DeviceMeasurementsSelectorComponent implements OnInit {

  private readonly DEFAULT_DEVICES_SORT_FIELD = 'serialNumber';
  private readonly DEFAULT_DEVICES_SORT_ORDER = 1;

  @Input() entityUuid: EntityWithUuid;
  @Input() tenant: Tenant;
  @Input() organization: Organization;
  @Input() selectionMode: 'single' | 'multiple' = 'single';
  @Output() selectionChange: EventEmitter<DeviceMeasurement | DeviceMeasurement[]>;
  @Output() visibleChange: EventEmitter<boolean>;

  public dialogVisible: boolean;
  public currentStep: number;

  public deviceSelection: EntityWithUuid | EntityWithUuid[];
  public deviceMeasurementSelection: DeviceMeasurement | DeviceMeasurement[];

  public deviceFilters: DeviceFilters;
  public deviceMeasurementFilters: {[field: string]: FilterMetadata};

  public initialSelection: DeviceMeasurement | DeviceMeasurement[];

  constructor() {
    this.selectionChange = new EventEmitter<DeviceMeasurement | DeviceMeasurement[]>();
    this.visibleChange = new EventEmitter<boolean>();
    this.currentStep = 0;
    this.deviceFilters = new DeviceFilters();
    this.deviceFilters.sortField = this.DEFAULT_DEVICES_SORT_FIELD;
    this.deviceFilters.sortOrder = this.DEFAULT_DEVICES_SORT_ORDER;
    this.deviceMeasurementFilters = {};
    this.deviceMeasurementFilters.name = { value: '', matchMode: FilterMatchMode.CONTAINS, operator: FilterOperator.AND };
    this.deviceMeasurementFilters['measurementType.unit'] =
      {
        value: '',
        matchMode: FilterMatchMode.CONTAINS,
        operator: FilterOperator.AND
      };
  }

  ngOnInit(): void {
    if (this.entityUuid?.uuid) {
      this.deviceFilters.uuids = [this.entityUuid.uuid];
      this.deviceSelection = this.entityUuid;
      this.currentStep = 1;
    }
  }

  @Input()
  set visible(visible: boolean) {
    this.dialogVisible = visible;
    if (!visible) {
      this.currentStep = 0;
    }
  }

  @Input()
  set selection(selection: DeviceMeasurement | DeviceMeasurement[]) {
    this.initialSelection = selection;

    if (this.selectionMode === 'multiple') {
      const arraySelection = selection as DeviceMeasurement[];
      this.deviceSelection = arraySelection.map(measurement => measurement.device);
      this.deviceMeasurementSelection = [...arraySelection];

    } else if (this.selectionMode === 'single') {
      const objectSelection = selection as DeviceMeasurement;
      if (objectSelection) {
        this.deviceSelection = objectSelection.device;
        this.deviceMeasurementSelection = objectSelection;
      }
    }
  }

  public updateDeviceMeasurementSelection(deviceSelection: EntityWithUuid | EntityWithUuid[]): void {
    if (this.selectionMode === 'multiple') {
      const arrayDeviceSelection = deviceSelection as EntityWithUuid[];
      const arrayDeviceMeasurementSelection = this.deviceMeasurementSelection as DeviceMeasurement[];
      const uuids = arrayDeviceSelection.map(value => value.uuid);
      this.deviceMeasurementSelection = arrayDeviceMeasurementSelection
        .filter(measurement => uuids.includes(measurement.device.uuid));

    } else if (this.selectionMode === 'single') {
      this.deviceMeasurementSelection = undefined;
    }
  }

  public saveAndClose(): void {
    this.selectionChange.emit(this.deviceMeasurementSelection);
    this.visible = false;
    this.visibleChange.emit(false);
  }

  public closeWithoutSaving(): void {
    this.selection = this.initialSelection;
    this.visible = false;
    this.visibleChange.emit(false);
  }

  public clearSelection(): void {
    this.deviceSelection = undefined;
    this.deviceMeasurementSelection = undefined;
  }

}
